import React, { useState, useEffect } from 'react';
// import { useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import {
    Nav,
    NavbarContainer,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
    NavBtn,
    NavBtnLink
} from './NavbarElements';
const Navbar = ({ toggle }) => {
    const [scrollNav, setScrollNav] = useState(false);
    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollNav(true);
        } else {
            setScrollNav(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, []);

    const toggleHome =()=>{
        scroll.scrollToTop();
    };

    return (
        <>
        <IconContext.Provider value={{color: 'green'}}>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo onClick={toggleHome}  to="/">dolla</NavLogo>
                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks 
                            to="about"
                            smooth={true}
                            duartion={500}
                            spy={true}
                            exact='true'
                            offset={-80}
                            activeClass="active"
                            >About</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="discover"smooth={true}
                            duartion={500}
                            spy={true}
                            exact='true'
                            offset={-80}
                            activeClass="active">Discover</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="services"smooth={true}
                            duartion={500}
                            spy={true}
                            exact='true'
                            offset={-80}
                            activeClass="active">Services</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="signup"smooth={true}
                            duartion={500}
                            spy={true}
                            exact='true'
                            offset={-80}
                            activeClass="active">Sign Up</NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavBtn>
                        <NavBtnLink to="/signin">Sign In</NavBtnLink>
                    </NavBtn>
                </NavbarContainer>
            </Nav>
            </IconContext.Provider>
        </>
    )
}

export default Navbar